import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Subject, ReplaySubject, Observable, of } from 'rxjs';
import { isNullOrUndefined } from '../objectUtils';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AlertService } from '../Alerts/alert.service';
import { ModalService } from '../Modal/ModalService';


@Injectable({ providedIn: 'root' })
export class SubscriberInformationService{

  private subscriberNumber: number;
  private subscriber: models.SubscriberInformationVM;

  constructor(private http: HttpClient, private location: Location, private modalService: ModalService) {
  }

  getCurrentSubscriber(): Observable<models.SubscriberInformationVM> {
    return of(this.subscriber);
  }

  setCurrentSubscriber(newSubscriberNumber: number, instanceID: number, workflowCode: string) {
    const instance = instanceID !== null && instanceID !== undefined ? instanceID.toString() : null;
    //newSubscriberNumber = 1000; // this hack provokes error on data integrity
    return this.http.get<models.SubscriberInformationVM>('api/SubscriberInfo/LoadSubscriberInformation', { params: { subscriberNumber: <any>newSubscriberNumber, instanceID: instance, workflowCode: workflowCode } }
    ).pipe(map(result => {
      //Need to make date an actual date since it comes in Json its defined as a string and not a date
      this.subscriber = { ...result, dateOfBirth: new Date(result.dateOfBirth) };
      //const timeZoneOffset = this.subscriber.dateOfBirth.getTimezoneOffset() * 6000;
      //this.subscriber.dateOfBirth = new Date(this.subscriber.dateOfBirth.getTime() - timeZoneOffset);
      this.subscriberNumber = newSubscriberNumber;
    }),
      catchError((err, caught) => {
        //caught.subscribe(rrr => {
        //  const a = rrr;
        //});
        var baseModal = <models.BaseModalVM>{ isError: true, message: "BaseModal.ErrorDataIntegrity" };
        return this.modalService.showModals([baseModal]).pipe(map(result => {
          //this.location.back();
          
        }));
        
        return of(err)
      }));
  }
}
